/**
 * Theme Footer View
 */
class ThemeFooterView {

	constructor(presenter, sectionId) {

		this.parent = $("#shopify-section-" + sectionId);
		this.newsletterEmail = $("#mon-footer-newsletter-email");
		this.newsletterSubmit = $("#mon-footer-newsletter-submit");
		this.navWishlist = this.parent.find(".mon-nav-wishlist");
		this.presenter = presenter;

		/*
		 * Listeners
		 */

		this.newsletterEmail.on("input", $.proxy(function(_event) {
			const isEmail = Model.isEmail(this.newsletterEmail.val());
			if (isEmail == true) {
				this.newsletterSubmit.prop("disabled", false);
			}
			else {
				this.newsletterSubmit.prop("disabled", true);
			}
		}, this));

	}

	/*
	 * Actions
	 */

	/*
	 * Getters and Setters
	 */

	setLocalStorageAvailable() {
		this.navWishlist.removeClass("d-none");
	}
	
}